// extracted by mini-css-extract-plugin
module.exports = {"root":"AcceptanceSetup_root__y0-CN","leftCol":"AcceptanceSetup_leftCol__3zHNg","selectedAddressCol":"AcceptanceSetup_selectedAddressCol__3il5k"};